export const RATING_COLOR_PRESETS = [
    "#82E01F",
    "#169F0B",
    "#36B5FD",
    "#183BB7",
    "#6C2181",
    "#B628F9",
    "#FA6400",
    "#F31515",
];

export const hexToRgb = (hex) => {
    const clean = (hex || "").replace("#", "").padEnd(6, "0").slice(0, 6);
    const bigint = parseInt(clean, 16) || 0;
    return {
        r: (bigint >> 16) & 255,
        g: (bigint >> 8) & 255,
        b: bigint & 255,
    };
};

export const rgbToHex = (r, g, b) => {
    const toHex = (n) => Math.max(0, Math.min(255, Number(n) || 0)).toString(16).padStart(2, "0");
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`.toUpperCase();
};
